<template>
  <path
    d="M14 6.00024V4.00024H10V6.00024H14ZM4 9.00024V18.0002C4 18.5502 4.45 19.0002 5 19.0002H19C19.55 19.0002 20 18.5502 20 18.0002V9.00024C20 8.45024 19.55 8.00024 19 8.00024H5C4.45 8.00024 4 8.45024 4 9.00024ZM20 6.00024C21.11 6.00024 22 6.89024 22 8.00024V19.0002C22 20.1102 21.11 21.0002 20 21.0002H4C2.89 21.0002 2 20.1102 2 19.0002L2.01 8.00024C2.01 6.89024 2.89 6.00024 4 6.00024H8V4.00024C8 2.89024 8.89 2.00024 10 2.00024H14C15.11 2.00024 16 2.89024 16 4.00024V6.00024H20Z"
  />
</template>
